<template>
  <div class="platform-info-container">
    <div class="container-logo">
      <div v-if="platformInfo.logo" class="platform-logo" :style="{'background-image':`url('${platformInfo.logo}')`}"></div>
      <div v-else class="platform-logo no-logo" :class="`color-${getColorName(platformInfo.name)}`">{{platformInfo.name[0]}}</div>
      <div class="platform-name">{{limitString(platformInfo.name,10)}}</div>
    </div>

    <div class="container-left">
      <p v-if="platformInfo.lineInfo" class="info-item"><span class="item-label">业务线：</span>{{platformInfo.lineInfo.name}}</p>
      <p v-if="platformInfo.slug" class="info-item"><span class="item-label">标识：</span>{{platformInfo.slug}}</p>
      <p v-if="platformInfo.managerName" class="info-item"><span class="item-label">负责人：</span>{{platformInfo.managerName}}</p>
      <p class="info-item"><span class="item-label">状态：</span>
        <el-tag size="mini" v-if="!platformInfo.isReject" type="success">正常</el-tag>
        <el-tag size="mini" v-else type="danger">删除</el-tag>
      </p>
      <p class="info-item"><span class="item-label">用户鉴权方式：</span>
        <el-tag size="mini" v-if="platformInfo.authType==='kylin'" type="danger">麒麟</el-tag>
        <el-tag size="mini" v-else type="warning">电商</el-tag>
      </p>
      <p v-if="platformInfo.type" class="info-item"><span class="item-label">OSS类型：</span>
        <el-tag size="mini" v-if="platformInfo.type==='aliCloud'" type="warning">阿里云</el-tag>
        <el-tag size="mini" v-if="platformInfo.type==='tencentCloud'" type="primary">腾讯云</el-tag>
        <el-tag size="mini" v-if="platformInfo.type==='jdCloud'" type="danger">京东云</el-tag>
      </p>
    </div>
    <div class="container-right">
      <p v-if="platformInfo.bucket" class="info-item"><span class="item-label">存储桶：</span>
        <a :title="platformInfo.bucket" class="cdn-address text-overflow-ellipsis" href="javascript:;" v-clipboard:copy="platformInfo.bucket" v-clipboard:success="onCopy">{{limitString(platformInfo.bucket,90)}}
        </a>
      </p>
      <p v-if="platformInfo.bucketRegion" class="info-item"><span class="item-label">存储桶区域：</span>{{platformInfo.bucketRegion}}</p>
      <p v-if="platformInfo.cdn" class="info-item"><span class="item-label">CDN加速域名：</span>{{platformInfo.cdn}}</p>
      <p v-if="platformInfo.createrName" class="info-item"><span class="item-label">创建人：</span>{{platformInfo.createrName}}</p>
      <p v-if="platformInfo.desc" class="info-item"><span class="item-label">平台描述：</span>
        <el-tooltip effect="dark" :content="platformInfo.desc" placement="top">
          <span>{{limitString(platformInfo.desc,20)}}</span>
        </el-tooltip>
      </p>
      <p v-if="platformInfo.createTime" class="info-item"><span class="item-label">创建时间：</span>{{formatTime(platformInfo.createTime)}}</p>
      <p v-if="platformInfo.updateTime" class="info-item"><span class="item-label">修改时间：</span>{{formatTime(platformInfo.updateTime)}}</p>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { limitString } from '@/common/utils/limit.js';
export default {
  name: 'platform-info',
  props: {
    platformInfo: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      colorsName: ['blue', 'indigo', 'purple', 'pink', 'red', 'orange', 'yellow', 'green', 'teal', 'cyan', 'primary', 'info', 'warning', 'danger', 'light'],
    }
  },
  methods: {
    // 获取颜色名称
    getColorName (name) {
      return this.colorsName[name.charCodeAt(0) % this.colorsName.length];
    },
    // 复制
    onCopy () {
      this.$message.success('复制成功', 2);
    },
    // 限制字符长度
    limitString (str, limit) {
      return limitString(str, limit)
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
  }
}
</script>

<style lang="scss" scoped>
.platform-info-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  .container-logo {
    .platform-logo {
      width: 160px;
      height: 160px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      &.no-logo {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 64px;
        color: #4f4f4f;
        border-radius: 50%;
        border: 1px dotted #ebeef5;
        background-color: #fff;
        object-fit: contain;
        font-weight: 700;
      }
    }
    .platform-name {
      margin-top: 20px;
      font-size: 18px;
      font-weight: 600;
      color: #718096;
      text-align: center;
    }
  }
  .container-logo,
  .container-left,
  .container-right {
    height: 250px;
  }

  .info-item {
    width: 100%;
    text-align: left;
    color: #718096;
    white-space: nowrap;
    .cdn-address {
      word-break: normal;
      word-wrap: normal;
      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>